import styled from "styled-components";

export interface IFlexProps {
  justify?: string;
  align?: string;
  direction?: string;
  gap?: string;
}

const Flex = styled.div<IFlexProps>`
  display: flex;
  flex-direction: ${props => props.direction};
  flex-wrap: wrap;
  justify-content: ${props => props.justify};
  align-items: ${props => props.align};
  ${props =>
    props.gap
      ? `margin-left: calc(-${props.gap}/2); margin-right: calc(-${props.gap}/2);`
      : null};
  > * {
    ${props =>
      props.gap
        ? `margin-left: calc(${props.gap}/2); margin-right: calc(${props.gap}/2); margin-bottom: ${props.gap};`
        : null};
  }
`;

Flex.defaultProps = {
  justify: "flex-start",
  align: "flex-start",
  direction: "row"
};

export default Flex;
